export default __webpack_public_path__ + "static/media/estimate.a8441540.svg";